module.exports = __webpack_public_path__ + "static/media/vedat.964d84c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/vedat.jpg
// module id = 257
// module chunks = 0